import { useDispatch, useSelector } from 'react-redux'
import ModalConfirm from '../../../components/Modals/Generales/ModalConfirm'
import ModalDelete from '../../../components/Modals/Generales/ModalDelete'

import { State } from '../../../reducers'

import { gp_lp_OpenModalEliminarProducto,
  gp_lp_OpenModalEstatus,
  gp_lp_SetProductoSeleccionado,
  gp_lp_OpenModalSucursales,
  gp_lu_changeEstatusProducto,
  gp_lp_EliminarProductoConfirm } from '../../../actions/gestion-producto/lista-producto/listaProductos.actions'
import { bindActionCreators } from 'redux'
import { actionsGPlistarProductos } from '../../../actions/action-creators'
import ModalConfirmClose from '../../../components/Modals/Generales/ModalConfirmClose'
import ModalSignacionSucursalesProducto from './ModalSignacionSucursalesProducto'

const ModalsControlsProduct= () => {
  const { activeSucursales, activeEliminar, activeEstatus } = useSelector(
    (state: State) => state.gestionProducto.listarProductos.modales
  )
  const { productoSeleccionado } = useSelector(
    (state: State) => state.gestionProducto.listarProductos
  )
  const dispatch = useDispatch()
  const actions = bindActionCreators(actionsGPlistarProductos, dispatch)

  const openModalSucursales = () => {
    dispatch(gp_lp_OpenModalSucursales(true))
  }

    const closeModalAceptarRechazar = () => {
      dispatch(gp_lp_OpenModalSucursales(false))
      dispatch(gp_lp_SetProductoSeleccionado(null))
    }

  const closeModalEliminar = () => {
    dispatch(gp_lp_OpenModalEliminarProducto(false))
    dispatch(gp_lp_SetProductoSeleccionado(null))
  }

  const closeModalEstatus = () => {
    dispatch(gp_lp_OpenModalEstatus(false))
    dispatch(gp_lp_SetProductoSeleccionado(null))
  }

  return (
    <>
      {activeSucursales && <ModalSignacionSucursalesProducto/>}
      {activeEliminar && (
        <ModalDelete
          title='Eliminar producto'
          detail={`¿Seguro que quieres eliminar el producto ${productoSeleccionado?.descripcion}?`}
          messageAction='Eliminar'
          actionDelete={() => dispatch(gp_lp_EliminarProductoConfirm())}
          closeModalDelete={closeModalEliminar}
          Styles={{ minWidth: '25%', maxWidth: '700px' }}
        />
      )}

      {activeEstatus && (
        <ModalConfirm
          title={`${productoSeleccionado?.activo === "Activo" ? 'Desactivar' : 'Activar'} producto`}
          detail={`¿Seguro que quieres realizar esta acción?`}
          actionConfirm={() => actions.gp_lu_changeEstatusProducto()}
          closeModalConfirm={closeModalEstatus}
        />
      )}

    </>
  )
}

export default ModalsControlsProduct
